import { render, staticRenderFns } from "./detalheslancto.vue?vue&type=template&id=4d94e65c&scoped=true"
import script from "./detalheslancto.vue?vue&type=script&lang=js"
export * from "./detalheslancto.vue?vue&type=script&lang=js"
import style0 from "./detalheslancto.vue?vue&type=style&index=0&id=4d94e65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94e65c",
  null
  
)

export default component.exports